<div class="container ninth-container my-70px">
  <div class="ninth-container-title">
    {{ 'home-page-content.frequently_asked_questions' | translate }}
  </div>
  <div class="ninth-container-body">
    <div class="row">
      @for (questionGroup of questions; track questionGroup) {
        <div class="col-6 flex-direction-column">
          @for (question of questionGroup; track question) {
            <div class="ninth-card"
                 (click)="toggleAnswerVisibility(question.id)"
                 [class]="question.showAnswer ? 'answer' : ''"
            >
              <div [class]="question.showAnswer ? 'flex-direction-column' : ''">
                <span>{{ question.question | translate }}</span>
                @if (question.showAnswer) {
                  <span class="answer-text">{{ question.answer | translate }}</span>
                }
              </div>
              @if (!question.showAnswer) {
                <img src="assets/homepage/frequently-asked-questions/open-with-bg.svg" alt="open svg">
              } @else {
                <img src="assets/homepage/frequently-asked-questions/close-with-bg.svg" alt="close svg">
              }
            </div>
          }
        </div>
      }
    </div>
  </div>
</div>
<section class="section-wrapper-mb ninth-container-mb my-70px">
  <div class="ninth-container-title" [ngClass]="{'ninth-container-title-mb': currentLang === Language.HY}">
    {{ 'home-page-content.frequently_asked_questions' | translate }}
  </div>
  <div class="ninth-container-body">
    <div class="flex-direction-column">
      @for (questionGroup of questions; track questionGroup) {
        <div>
          @for (question of questionGroup; track question) {
            <div class="ninth-card"
                 (click)="toggleAnswerVisibility(question.id)"
                 [class]="question.showAnswer ? 'answer' : ''">
              <div [class]="question.showAnswer ? 'flex-direction-column' : ''">
                <span>{{ question.question | translate }}</span>
                @if (question.showAnswer) {
                  <span class="answer-text">{{ question.answer | translate }}</span>
                }
              </div>
              @if (!question.showAnswer) {
                <img src="assets/homepage/frequently-asked-questions/open-with-bg.svg" alt="open svg">
              } @else {
                <img src="assets/homepage/frequently-asked-questions/close-with-bg.svg" alt="close svg">
              }
            </div>
          }
        </div>
      }
    </div>
  </div>
</section>
